export default __webpack_public_path__ + "static/media/portugal.b215c862.svg";